<script>import { lowerCase } from "lodash"
import Datepicker from "vuejs-datepicker"
import { ptBR } from "vuejs-datepicker/dist/locale"
import SearchSelect from "@/core/components/SearchSelect.vue"
import { dateFormat } from "@/core/services/helpers"
export default {
  components: {
    SearchSelect,
    Datepicker,
  },
  props: {
    lineModel: {
      type: Object,
      required: true,
    },
    simulateSubmitLineForm: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    locale: ptBR,
    dateFormat,
    tpOutorgaOptions: [
      { value: 1, label: "Concessão" },
      { value: 2, label: "Permissão" },
      { value: 3, label: "Autorização" },
      { value: 4, label: "Licença" },
      { value: 5, label: "Sub Judice" },
      { value: 6, label: "T. Precário" },
      { value: 7, label: "Prec/ANTT" },
      { value: 8, label: "ACORDO ACP" },
    ],
    nuServicoVeiculoOptions: [
      { value: 1, label: "Urbano" },
      { value: 2, label: "Semi-Urbano" },
      { value: 3, label: "Rodoviário" },
      { value: 4, label: "Executivo 'A'" },
      { value: 6, label: "Leito 'A'" },
      { value: 7, label: "Leito 'B'" },
      { value: 8, label: "Micro 'A'" },
      { value: 9, label: "Micro 'B'" },
    ],
    transportadora: {
      id: null,
      name: "",
    },
    linhaInfo: false,
    ramalInfo: false,
  }),
  computed: {
    lineForm() {
      return this.lineModel
    },
  },
  watch: {
    lineModel: {
      handler() {
        this.transportadora = {
          id: this.lineModel.transportadoraForm.id ?? null,
          name: this.lineModel.transportadoraForm.name ?? "",
        }
      },
      deep: true,
    },
    simulateSubmitLineForm: {
      handler() {
        this.$refs.submitButtonLineInfoForm.click()
      },
      deep: true,
    },
  },
  methods: {
    submitLineForm() {
      this.$emit("submit", this.lineForm)
    },
    validateNuLinhaOnInput(value) {
      let originalValue = value.slice(0, -1)
      let valid = true

      if (value.length > 4) {
        valid = false
      }

      if (
        isNaN(value.charAt(value.length - 1)) ||
        value.charAt(value.length - 1) == " "
      ) {
        valid = false
      }

      if (valid) {
        this.lineForm.nulinharamal = value
      } else {
        this.lineForm.nulinharamal = originalValue
      }
    },
    validateNuExtensaoOnInput(value) {
      let originalValue = value.slice(0, -1)
      let valid = true

      if (value.length > 2) {
        valid = false
      }

      if (
        isNaN(value.charAt(value.length - 1)) ||
        value.charAt(value.length - 1) == " "
      ) {
        valid = false
      }

      if (valid) {
        this.lineForm.nuextensao = value
      } else {
        this.lineForm.nuextensao = originalValue
      }
    },
    validateVlCoeficienteOnInput(value) {
      let originalValue = value.slice(0, -1)
      let valid = true

      if (value.length > 4) {
        valid = false
      }

      if (
        isNaN(value.charAt(value.length - 1)) &&
        value.charAt(value.length - 1) !== "."
      ) {
        valid = false
      }

      // valida primeiro digito
      if (value.length == 1) {
        valid = new RegExp(/^[0-9]$/).test(value.charAt(0))
        value += "."
      }

      // valida terceiro digito
      if (value.length == 3) {
        valid = new RegExp(/^[0-9]$/).test(value.charAt(2))
      }

      // valida quarto digito
      if (value.length == 4) {
        valid = new RegExp(/^[0-9]$/).test(value.charAt(3))
      }

      if (valid) {
        this.lineForm.vlcoeficientemultiplicacao = value
      } else {
        this.lineForm.vlcoeficientemultiplicacao = originalValue
      }
    },

    capitalize(string) {
      let arrayPalavras = string.split(" ")
      let arrayPalavrasCapitalized = arrayPalavras.map(
        (palavra) =>
          palavra.charAt(0).toUpperCase() + lowerCase(palavra.slice(1))
      )
      return arrayPalavrasCapitalized.join(" ")
    },

    changeNuTransportadora(transportadora) {
      this.lineForm.nutransportadora = transportadora.id
      this.lineForm.transportadoraForm = {
        id: transportadora.id,
        name: this.capitalize(transportadora.business_name),
      }
    },

    changeFormInfo() {
      this.$emit("changeLineForm", true)
    },
  },
}
</script>
<template>
  <form
    class="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-6 gap-4"
    @submit.prevent="submitLineForm"
    @change="changeFormInfo"
  >
    <div class="sm:col-span-2 lg:col-span-1 mb-3">
      <label class="form-label" for="linha">Linha</label>
      <div class="relative">
        <input
          id="linha"
          v-model="lineForm.nulinharamal"
          type="text"
          disabled
          class="form-input bg-gray-200"
          required
          @input="
                        $event => validateNuLinhaOnInput($event.target.value)
                    "
        >
        <span
          v-if="lineForm.nulinharamal == '----'"
          class="absolute inset-y-0 right-0 flex items-center pr-3"
          @mouseover="linhaInfo = true"
          @mouseleave="linhaInfo = false"
          >&#x1F6C8;</span
        >
        <div
          v-if="linhaInfo"
          class="absolute top-0 left-full z-50 bg-green-background text-white p-3 shadow-md w-64"
        >
          <p>O número da linha será gerado após a validação do formulário.</p>
        </div>
      </div>
    </div>
    <div class="sm:col-span-2 lg:col-span-1 mb-3">
      <label class="form-label" for="extensao">Ramal</label>
      <div class="relative">
        <input
          id="extensao"
          v-model="lineForm.nuextensao"
          type="text"
          class="form-input bg-gray-200"
          disabled
          @input="
                        $event => validateNuExtensaoOnInput($event.target.value)
                    "
        >
        <span
          v-if="lineForm.nuextensao == '--'"
          class="absolute inset-y-0 right-0 flex items-center pr-3"
          @mouseover="ramalInfo = true"
          @mouseleave="ramalInfo = false"
          >&#x1F6C8;</span
        >
        <div
          v-if="ramalInfo"
          class="absolute top-0 left-full z-50 bg-green-background text-white p-3 shadow-md w-64"
        >
          <p>O número do ramal será gerado após a validação do formulário.</p>
        </div>
      </div>
    </div>
    <div class="sm:col-span-4 lg:col-span-2 mb-3">
      <label class="form-label" for="nomelinha">Nome da Linha</label>
      <input
        id="nomelinha"
        v-model="lineForm.nomelinha"
        type="text"
        class="form-input"
        required
      >
    </div>
    <div class="sm:col-span-4 lg:col-span-2 mb-3">
      <label class="form-label" for="transportadora">Transportadora</label>
      <SearchSelect
        :selected.sync="transportadora"
        :search-keys="[]"
        :search-remote="true"
        :lazy-load="true"
        options-url="/api/registry/organizations/"
        :digits-before-search="3"
        option-key="transportadora"
        field-class=""
        name="organization"
        :option-value="
                    transportadora => capitalize(transportadora.name)
                "
        @changed="changeNuTransportadora"
      ></SearchSelect>
    </div>

    <div
      class="sm:col-span-4 lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4"
    >
      <div class="mb-4">
        <label class="form-label" for="tipo-viagem">Tipo de Viagem</label>
        <div class="">
          <div class="flex mb-2">
            <input
              id="tipo-comum"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="comum"
              value="1"
              type="radio"
            >
            <label class="form-label flex items-center mb-0" for="tipo-comum">
              Comum
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="tipo-seletivo"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="tipo-seletivo"
              value="2"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="tipo-seletivo"
            >
              Seletivo
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="tipo-convencional"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="tipo-convencional"
              value="3"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="tipo-convencional"
            >
              Convencional
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="tipo-semi-direto"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="tipo-semi-direto"
              value="4"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="tipo-semi-direto"
            >
              Semi Direto
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="tipo-direto"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="tipo-direto"
              value="5"
              type="radio"
            >
            <label class="form-label flex items-center mb-0" for="tipo-direto">
              Direto
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="tipo-especial"
              v-model="lineForm.tpviagem"
              class="h-6 w-6 mr-2"
              name="tipo-especial"
              value="6"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="tipo-especial"
            >
              Especial
            </label>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label" for="operacao">Operação</label>
        <div class="">
          <div class="flex mb-2">
            <input
              id="operacao-rodoviaria"
              v-model="lineForm.tpoperacao"
              class="h-6 w-6 mr-2"
              name="operacao-rodoviaria"
              value="1"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="operacao-rodoviaria"
            >
              Rodoviária
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="operacao-urbana"
              v-model="lineForm.tpoperacao"
              class="h-6 w-6 mr-2"
              name="operacao-urbana"
              value="2"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="operacao-urbana"
            >
              Urbana
            </label>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label" for="tipo-veiculo">Regime da Linha</label>
        <div class="">
          <div>
            <div class="flex mb-2">
              <input
                id="tpservccompl-original"
                v-model="lineForm.tpservcompl"
                class="h-6 w-6 mr-2"
                name="tpservccompl-original"
                value="1"
                type="radio"
              >
              <label
                class="form-label flex items-center mb-0"
                for="tpservccompl-original"
              >
                Original
              </label>
            </div>
            <div class="flex mb-2">
              <input
                id="tpservccompl-parcial"
                v-model="lineForm.tpservcompl"
                class="h-6 w-6 mr-2"
                name="tpservccompl-parcial"
                value="2"
                type="radio"
              >
              <label
                class="form-label flex items-center mb-0"
                for="tpservccompl-parcial"
              >
                Parcial
              </label>
            </div>
            <div class="flex mb-2">
              <input
                id="tpservccompl-ramal"
                v-model="lineForm.tpservcompl"
                class="h-6 w-6 mr-2"
                name="tpservccompl-ramal"
                value="3"
                type="radio"
              >
              <label
                class="form-label flex items-center mb-0"
                for="tpservccompl-ramal"
              >
                Ramal
              </label>
            </div>
            <div class="flex mb-2">
              <input
                id="tpservccompl-sobra-residual"
                v-model="lineForm.tpservcompl"
                class="h-6 w-6 mr-2"
                name="tpservccompl-sobra-residual"
                value="4"
                type="radio"
              >
              <label
                class="form-label flex items-center mb-0"
                for="tpservccompl-sobra-residual"
              >
                Sobra/Residual
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label" for="toalete">Toalete</label>
        <div class="">
          <div class="flex mb-2">
            <input
              id="toalete-sim"
              v-model="lineForm.fltoalete"
              class="h-6 w-6 mr-2"
              name="toalete-sim"
              value="1"
              type="radio"
            >
            <label class="form-label flex items-center mb-0" for="toalete-sim">
              Sim
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="toalete-nao"
              v-model="lineForm.fltoalete"
              class="h-6 w-6 mr-2"
              name="toalete-nao"
              value="0"
              type="radio"
            >
            <label class="form-label flex items-center mb-0" for="toalete-nao">
              Não
            </label>
          </div>
        </div>
      </div>

      <!-- <div class="mb-3">
                <label class="form-label" for="patamar">Patamarizada</label>
                <div class="">
                    <div class="flex mb-2">
                        <input
                            id="patamar-sim"
                            v-model="lineForm.patamarizada"
                            class="h-6 w-6 mr-2"
                            name="patamar-sim"
                            value="1"
                            type="radio"
                        />
                        <label
                            class="form-label flex items-center mb-0"
                            for="patamar-sim"
                            >Sim</label
                        >
                    </div>
                    <div class="flex mb-2">
                        <input
                            id="patamar-nao"
                            v-model="lineForm.patamarizada"
                            class="h-6 w-6 mr-2"
                            name="patamar-nao"
                            value="0"
                            type="radio"
                        />
                        <label
                            class="form-label flex items-center mb-0"
                            for="patamar-nao"
                            >Não</label
                        >
                    </div>
                </div>
            </div> -->

      <div class="mb-4">
        <label class="form-label" for="status">Ativo</label>
        <div class="">
          <div class="flex mb-2">
            <input
              id="status-ativo"
              v-model="lineForm.flsituacao"
              class="h-6 w-6 mr-2"
              name="status-ativo"
              value="1"
              type="radio"
            >
            <label class="form-label flex items-center mb-0" for="status-ativo">
              Sim
            </label>
          </div>
          <div class="flex mb-2">
            <input
              id="status-inativo"
              v-model="lineForm.flsituacao"
              class="h-6 w-6 mr-2"
              name="status-inativo"
              value="3"
              type="radio"
            >
            <label
              class="form-label flex items-center mb-0"
              for="status-inativo"
            >
              Não
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="coeficiente-tarifario">
        Coeficiente de Multiplicação de Tarifa
      </label>
      <input
        id="coeficiente-tarifario"
        v-model="lineForm.vlcoeficientemultiplicacao"
        type="text"
        min="0"
        class="form-input"
        required
        @input="
                    $event => validateVlCoeficienteOnInput($event.target.value)
                "
      >
    </div>
    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="servico-veiculo">Serviço do Veículo</label>
      <select
        id="servico-veiculo"
        v-model="lineForm.nuservicoveiculo"
        class="form-select p-3"
        required
      >
        <option
          v-for="option in nuServicoVeiculoOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="outorga-linha">Outorga da Linha</label>
      <select
        id="outorga-linha"
        v-model="lineForm.tpoutorga"
        class="form-select p-3"
        required
      >
        <option
          v-for="option in tpOutorgaOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="inicio-contrato">Inicio de Contrato</label>
      <Datepicker
        v-model="lineForm.dtiniciocontrato"
        format="dd/MM/yyyy"
        :language="locale"
        :full-month-name="true"
        input-class="form-input mb-0"
        class="date-picker-line-form"
      />
    </div>
    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="fim-contrato">Fim de Contrato</label>
      <Datepicker
        v-model="lineForm.dtfimcontrato"
        format="dd/MM/yyyy"
        :language="locale"
        :full-month-name="true"
        input-class="form-input mb-0"
        class="date-picker-line-form"
      />
    </div>

    <div class="sm:col-span-2 lg:col-span-2 mb-3">
      <label class="form-label" for="inicio-operacao">Inicio da Operação</label>
      <Datepicker
        v-model="lineForm.dtiniciolinha"
        format="dd/MM/yyyy"
        :language="locale"
        :full-month-name="true"
        input-class="form-input mb-0"
        class="date-picker-line-form"
      />
    </div>
    <button ref="submitButtonLineInfoForm" type="submit" class="invisible">
      Avançar
    </button>
  </form>
</template>
<style>.date-picker-line-form .vdp-datepicker__calendar {
  bottom: 100%;
  display: block;
}
</style>
